/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var menu_tabbing_service_1 = require("./menu-tabbing.service");
var core_1 = require("@angular/core");
var filter_host_directive_1 = require("../filter-host.directive");
var utils_1 = require("../../utils");
var filter_menu_component_factory_1 = require("./filter-menu-component.factory");
var string_filter_menu_component_1 = require("./string-filter-menu.component");
var filter_service_1 = require("../filter.service");
/**
 * @hidden
 */
var FilterMenuHostDirective = /** @class */ (function (_super) {
    tslib_1.__extends(FilterMenuHostDirective, _super);
    function FilterMenuHostDirective(host, resolver) {
        return _super.call(this, host, resolver) || this;
    }
    FilterMenuHostDirective.prototype.componentType = function () {
        if (utils_1.isPresent(this.column) && !utils_1.isNullOrEmptyString(this.column.filter)) {
            return filter_menu_component_factory_1.filterMenuComponentFactory(this.column.filter);
        }
        return string_filter_menu_component_1.StringFilterMenuComponent;
    };
    FilterMenuHostDirective.prototype.initComponent = function (ctx) {
        _super.prototype.initComponent.call(this, ctx);
        this.component.instance.filterService = this.filterService;
        this.component.instance.menuTabbingService = this.menuTabbingService;
    };
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", filter_service_1.FilterService)
    ], FilterMenuHostDirective.prototype, "filterService", void 0);
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", menu_tabbing_service_1.MenuTabbingService)
    ], FilterMenuHostDirective.prototype, "menuTabbingService", void 0);
    FilterMenuHostDirective = tslib_1.__decorate([
        core_1.Directive({
            selector: '[kendoFilterMenuHost]'
        }),
        tslib_1.__metadata("design:paramtypes", [core_1.ViewContainerRef,
            core_1.ComponentFactoryResolver])
    ], FilterMenuHostDirective);
    return FilterMenuHostDirective;
}(filter_host_directive_1.FilterHostDirective));
exports.FilterMenuHostDirective = FilterMenuHostDirective;
